import config from '../config';


export const API_ENDPOINTS = {
  hubFindOrCreateUrl: '/api/v1/users/find_or_create',
  hubSendOTP: '/api/v1/otps',
  hubSendVerificationLink: '/api/v1/verification_links',
  hubVerifyOtp: '/api/v1/otps/verify',
  hubSetPassword: '/api/v1/users/passwords',
  hubLogin: '/oauth/token',
  hubToken: '/oauth/token.json',
  UPDATE_USER_PROFILE: '/api/v1/users/update',
  hubForgotPassword: '/users/password/new',
  hubResetLink: '/api/v1/users/passwords',
  FETCH_PARTNER_DETAILS: '/api/v1/partners/fetch_platform_details_signup',
}


export default function getEndPoint(endpoint) {
  const hubBasePath = config.get('hubHost', '');
  return hubBasePath + API_ENDPOINTS[endpoint];
}